import { render, staticRenderFns } from "./WidgetUnpaid.vue?vue&type=template&id=6c364b58&"
import script from "./WidgetUnpaid.vue?vue&type=script&lang=js&"
export * from "./WidgetUnpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports